import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { isNullOrWhitespace } from "@utils";
import { useWatch } from "react-hook-form";

export const useFieldValidation = (field: string, triggerField: string) => {
	const fieldValue = useWatch({ name: field });
	const triggeredFieldValue = useWatch({ name: triggerField });
	const { getFieldState, getValues, trigger } = useFormContext();

	useEffect(() => {
		const isEqual = getValues(field) == getValues(triggerField);

		if (
			!isNullOrWhitespace(getValues(field)) &&
			((getFieldState(field).isTouched &&
				getFieldState(triggerField).isTouched) ||
				isEqual ||
				(!isNullOrWhitespace(getValues(triggerField)) && !isEqual))
		) {
			trigger(triggerField);
		}
	}, [fieldValue, triggeredFieldValue]);
};
